import { useIntlayer } from 'react-intlayer';

import { ProductCTASection } from '~/components/ui/ProductCTASection';
import { ProductDescriptionSection } from '~/components/ui/ProductDescriptionSection';
import { ProductFeatureBlock } from '~/components/ui/ProductFeatureBlock';
import { ProductHeroSection } from '~/components/ui/ProductHeroSection';
import { ProductKeyFeaturesSection } from '~/components/ui/ProductKeyFeaturesSection';
import { ProductMainPhraseSection } from '~/components/ui/ProductMainPhraseSection';

export const ChornaPageContent = () => {
  const {
    keyFeatures,
    cta,
    hero,
    mainPhrase,
    description,
    features: featureTiles,
  } = useIntlayer('chorna');

  const features = [
    {
      number: keyFeatures.feature01.number,
      title: keyFeatures.feature01.title,
      description: keyFeatures.feature01.description,
      image: '/assets/images/chorna_key_feature_1.jpg',
    },
    {
      number: keyFeatures.feature02.number,
      title: keyFeatures.feature02.title,
      description: keyFeatures.feature02.description,
      image: '/assets/images/chorna_key_feature_2.jpg',
    },
    {
      number: keyFeatures.feature03.number,
      title: keyFeatures.feature03.title,
      description: keyFeatures.feature03.description,
      image: '/assets/images/TrypillianStills_5.2.1.png',
    },
    {
      number: keyFeatures.feature04.number,
      title: keyFeatures.feature04.title,
      description: keyFeatures.feature04.description,
      image: '/assets/images/chorna_key_feature_3.jpg',
    },
  ];
  return (
    <div className="bg-black min-h-full w-full">
      <ProductHeroSection
        subtitle={hero.subtitle}
        title={hero.title}
        videoSrc="/assets/video/hls/Chorna_180226_mp4/master.m3u8"
        fallbackVideoSrc="/assets/video/Chorna_180226_mp4.mp4"
        titleClassName="md:text-[36px] md:tracking-[0.36px]"
      />

      <ProductMainPhraseSection text={mainPhrase.line1.value} />

      <section className="relative w-full">
        <div className="w-full flex items-center justify-center">
          <div>
            <img
              src="/assets/images/chorna_large.jpg"
              alt=""
              className="w-full aspect-[375/560] md:aspect-auto lg:h-[1120px] object-cover object-[15%_center] md:object-center"
            />
          </div>
        </div>
        <div className="absolute inset-0 py-10 lg:py-20 px-4 md:px-8 lg:px-20">
          <ProductDescriptionSection
            text={description.value}
            className="bg-transparent py-0"
          />
        </div>
      </section>
      <ProductFeatureBlock
        code={featureTiles.c01.code}
        label={featureTiles.c01.label}
        title={featureTiles.c01.title}
      />
      <section className="relative w-full flex flex-col md:flex-row md:flex-wrap md:items-end">
        <div className="w-full flex items-center justify-center">
          <img
            src="/assets/images/chorna_balloons.jpg"
            alt=""
            className="w-full aspect-[375/560] md:aspect-auto md:h-[705px] lg:h-[1120px] object-cover"
          />
        </div>
      </section>
      <section className="relative w-full flex flex-col md:flex-row">
        <ProductFeatureBlock
          code={featureTiles.c02.code}
          label={featureTiles.c02.label}
          title={featureTiles.c02.title}
        />
        <ProductFeatureBlock
          code={featureTiles.c03.code}
          label={featureTiles.c03.label}
          title={featureTiles.c03.title}
          className="bg-graphite-primary"
        />
      </section>
      <ProductKeyFeaturesSection
        title={keyFeatures.title}
        features={features}
      />

      <ProductCTASection
        title={cta.title}
        heading={hero.title}
        button1Text={cta.button1}
        backgroundImage="/assets/images/chorna_cta.jpg"
        imageClassName="flip-horizontal"
      />
    </div>
  );
};
